<ahp-dynamic-form
	#dateCollector
	class="date-collection--form"
	[ariaDescribedBy]="labelId"
	[controls]="controls"
	[formSubmitted]="formSubmitted"
	(formValidityChange)="formValidityChanged($event)"
></ahp-dynamic-form>
